export default function () {
  const widgetName = 'cardWidgetSecondFeature';
  const widgetOpts = cardWidgetSecondFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (slide) {

      function addClass() {
        $(`#${widgetName} .card-widget-item`).each(function () {
          $(this).attr('target',"")
          $(this).attr('title','Read More')
          $(this).find(".moreButton").addClass("button");
          $(this).find(".buyNowButton").addClass("button");
    
          $(this).find('.card-widget-title, .card-widget-description, .card-widget-title-h2').wrapAll(`<div class="text-wraper"></div>`)
          $(this).find('.card-content').prepend('<div class="overlay-card"></div>')
          $(this).find(".moreButton").removeClass("moreButton");
          $(this).find(".button").attr("target", "");

              if ($(this).find(".card-widget-description").text() == "") {
                $(this).find(".card-widget-description").css('display', 'none')
                $(this).find(".text-wraper").css('margin', '0')
              }

              if ($(this).find(".button").length < 1) {
                $(this).find(".text-wraper").css('margin', '0')
                $(this).find(".card-content").css('cursor', 'default')
              }
        })
      }
      addClass()
      
    },
    buyNowButton: {
      visible: false,
      text: 'BUY NOW!'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'More'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true
  });
}